import React, { useState, useEffect } from 'react';

import { Form, Select, Spin, Empty } from 'antd';
import { useLazyQuery } from '@apollo/react-hooks';

import { useDebounce } from 'utilities';
import { SEARCH_USERS } from 'services';

const { Option } = Select;

const SelectUser = ({ setSelectedKeys, selectedKeys, forwardedRef }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  const [searchUsers, { loading, data }] = useLazyQuery(SEARCH_USERS, {
    variables: {
      userPhoneNumber: debouncedSearchTerm,
    },
  });

  useEffect(() => {
    if (debouncedSearchTerm) {
      searchUsers();
    }
  }, [debouncedSearchTerm, searchUsers]);

  const onChange = (value) => {
    if (!value) {
      setSelectedKeys(null);
    }
  };

  return (
    <Select
      loading={loading}
      onSearch={(searchValue) => setSearchTerm(searchValue)}
      onSelect={(value) => setSelectedKeys(value)}
      showSearch
      showArrow={false}
      filterOption={false}
      allowClear={true}
      notFoundContent={
        !debouncedSearchTerm ? null : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )
      }
      value={selectedKeys}
      onChange={onChange}
      placeholder="Search by user phone"
      style={{ width: 188, marginBottom: 8, display: 'block' }}
      ref={forwardedRef}
    >
      {debouncedSearchTerm ? (
        loading ? (
          <Option value={null} disabled style={{ textAlign: 'center' }}>
            <Spin tip="Loading Users..." />
          </Option>
        ) : (
          data &&
          data.searchUsers.map((user) => (
            <Option key={user.id} value={user.id}>
              {user.name}
            </Option>
          ))
        )
      ) : null}
    </Select>
  );
};

export default SelectUser;
